import React from 'react';
import { List, ListItem, ListItemButton, ListItemText, ListItemIcon, Typography, Grid, CardContent, Card, CardActions, Button } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import ArrowLinkIcon from '../../images/arrowLink.svg';
import { useStyles } from './style'
import { handleCardClick } from './utils';

interface LinkData {
  title: string;
  text: string;
  path: string;
}

interface ResourceCardsProps {
  xs: number;
  md: number;
  links: LinkData[];
}

export const ResourceCards = ({ xs, md, links }: ResourceCardsProps) => {
  const navigate = useNavigate();
  const classes = useStyles();

  return (
    <Grid container className={classes.resourceCards}>
      {links.map((link, index) => (
        <Grid item xs={xs} md={md}>
          <Card key={index} variant="outlined" className={classes.resourceCard}>
            <CardContent onClick={() => handleCardClick(link.path, navigate)}>
              <Grid container>
                <Grid item xs={12} md={9}>
                  <Typography variant="h6">{link.title}</Typography>
                </Grid>
                <Grid item xs={12} md={3}>
                  <Button>
                    <img src={ArrowLinkIcon} alt="Arrow Link" className={classes.resourceCardImage} />
                  </Button>
                </Grid>
                <Grid item xs={12} md={12}>
                  <Typography variant="body1">{link.text}</Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default ResourceCards; 